export class WKTObject {
    constructor(
        readonly srid: number,
        readonly wkt: string,
        readonly egengeometri: boolean | null = null,
        readonly forenklet: boolean | null = null
    ) {}
}
